import { Pipe, type PipeTransform } from '@angular/core';

const MAX_VERSION_LEVEL = 3;

@Pipe({
    name: 'minAppVersion',
})
export class MinAppVersionPipe implements PipeTransform {
    private currentParts: string[] = [];
    private minParts: string[] = [];

    public transform(current = '0.0.0', min = '0.0.0'): boolean {
        if (!current || !min) {
            return false;
        }
        this.currentParts = current.split('.');
        this.minParts = min.split('.');

        return this.checkVersion();
    }

    private checkVersion(level = 0): boolean {
        if (level >= MAX_VERSION_LEVEL) {
            return true;
        }
        const current = Number.parseInt(this.currentParts[level], 10);
        const min = Number.parseInt(this.minParts[level], 10);
        if (current < min) {
            return false;
        }
        if (current > min) {
            return true;
        }

        return this.checkVersion(level + 1);
    }
}
